import { useState } from "react";
import MovieList from "./components/MovieList";
import Filter from "./components/Filter";
import AddMovie from "./components/AddMovie";
import "./App.css";

const INITIAL_MOVIES = [
  {
    id: 1,
    title: "Dune: Part Two",
    description:
      "Paul Atreides unites with Chani and the Fremen while on a warpath of revenge against the conspirators who destroyed his family.",
    posterURL:
      "https://image.tmdb.org/t/p/w500/1pdfLvkbY9ohJlCjQH2CZjjYVvJ.jpg",
    rating: 8.5,
  },
  {
    id: 2,
    title: "Oppenheimer",
    description:
      "The story of American scientist J. Robert Oppenheimer and his role in the development of the atomic bomb during World War II.",
    posterURL:
      "https://image.tmdb.org/t/p/w500/8Gxv8gSFCU0XGDykEGv7zR1n2ua.jpg",
    rating: 8.9,
  },
  {
    id: 3,
    title: "Inception",
    description:
      "A thief who steals corporate secrets through the use of dream-sharing technology is given the inverse task of planting an idea.",
    posterURL:
      "https://image.tmdb.org/t/p/w500/oYuLEt3zVCKq57qu2F8dT7NIa6f.jpg",
    rating: 8.8,
  },
  {
    id: 4,
    title: "The Bear",
    description:
      "A young chef from the fine dining world returns to Chicago to run his family's sandwich shop and turns the place upside down.",
    posterURL:
      "https://image.tmdb.org/t/p/w500/sHFlbKS3WLqMnp9t2ghADIJFnuQ.jpg",
    rating: 8.7,
  },
  {
    id: 5,
    title: "Interstellar",
    description:
      "A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival.",
    posterURL:
      "https://image.tmdb.org/t/p/w500/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg",
    rating: 8.6,
  },
  {
    id: 6,
    title: "Severance",
    description:
      "Mark leads a team of office workers whose memories have been surgically divided between their work and personal lives.",
    posterURL:
      "https://image.tmdb.org/t/p/w500/pOmLjGd5GyRCKyGMvXGBpyVYNom.jpg",
    rating: 8.7,
  },
];

export default function App() {
  const [movies, setMovies] = useState(INITIAL_MOVIES);
  const [filterTitle, setFilterTitle] = useState("");
  const [filterRating, setFilterRating] = useState(0);
  const [showForm, setShowForm] = useState(false);

  // ── Filtering logic ────────────────────────────────────────────
  const filteredMovies = movies.filter((m) => {
    const matchTitle = m.title
      .toLowerCase()
      .includes(filterTitle.toLowerCase());
    const matchRating = m.rating >= filterRating;
    return matchTitle && matchRating;
  });

  // ── Add movie ──────────────────────────────────────────────────
  const handleAddMovie = (newMovie) => {
    setMovies((prev) => [{ ...newMovie, id: Date.now() }, ...prev]);
    setShowForm(false);
  };

  return (
    <div className="app">
      <div className="noise" />

      {/* ── Hero header ── */}
      <header className="hero">
        <div className="hero__inner">
          <p className="hero__label">Your Personal</p>
          <h1 className="hero__title">
            CineVault<span className="hero__dot">.</span>
          </h1>
          <p className="hero__sub">{movies.length} titles in your collection</p>
        </div>
        <button
          className={`fab ${showForm ? "fab--close" : ""}`}
          onClick={() => setShowForm((v) => !v)}
          aria-label="Add movie"
        >
          {showForm ? "✕" : "+"}
        </button>
      </header>

      <div className="content">
        {/* ── Add form (slide-down) ── */}
        <div className={`form-wrap ${showForm ? "form-wrap--open" : ""}`}>
          <AddMovie onAdd={handleAddMovie} />
        </div>

        {/* ── Filter bar ── */}
        <Filter
          title={filterTitle}
          rating={filterRating}
          onTitleChange={setFilterTitle}
          onRatingChange={setFilterRating}
        />

        {/* ── Movie grid ── */}
        <MovieList movies={filteredMovies} />
      </div>
    </div>
  );
}
